import React from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import TextInput from "../../components/TextInput/TextInput";
import TextAreaInput from "../../components/TextAreaInput/TextAreaInput";
import { FormField, TextObject, WuiltContext, FieldType } from "@/shared/types";

interface TextFieldProps {
  isError?: boolean;
  field: FormField;
  useFormProps: UseFormReturn<FieldValues, any>;
  isSubmitting: boolean;
  text: TextObject;
  wuiltContext?: WuiltContext;
}

const TextField: React.FC<TextFieldProps> = ({
  isError,
  useFormProps,
  field,
  text,
  wuiltContext,
}) => {
  const { min, max, minLength, maxLength } = field?.settings || {};
  const Component =
    field?.type === FieldType.TextArea ? TextAreaInput : TextInput;

  return (
    <Component
      id={field?.id}
      isError={isError}
      fieldSettings={field?.settings || {}}
      text={text}
      wuiltContext={wuiltContext}
      registerProps={{
        ...useFormProps?.register(field?.id, {
          max,
          min,
          maxLength,
          minLength,
        }),
      }}
    />
  );
};

export default TextField;
